import React from 'react';

const ReturnPolicyPage = React.lazy(() => import('pages/ReturnPolicy/ReturnPolicyPage'));
const ReturnPolicyAddPage = React.lazy(() => import('pages/ReturnPolicy/ReturnPolicyAddPage'));

const returnPolicyRoute = [
  {
    path: '/return-policy',
    exact: true,
    name: 'Chính sách nhập lại / thu cũ đổi mới',
    function: 'PRO_RETURNPOLICY_VIEW',
    component: ReturnPolicyPage,
  },
  {
    path: '/return-policy/add',
    exact: true,
    name: 'Thêm chính sách nhập lại / thu cũ đổi mới',
    function: 'PRO_RETURNPOLICY_ADD',
    component: ReturnPolicyAddPage,
  },
  {
    path: '/return-policy/edit/:id',
    exact: true,
    name: 'Chỉnh sửa chính sách nhập lại / thu cũ đổi mới',
    function: 'PRO_RETURNPOLICY_EDIT',
    component: ReturnPolicyAddPage,
  },
  {
    path: '/return-policy/detail/:id',
    exact: true,
    name: 'Chi tiết chính sách nhập lại / thu cũ đổi mới',
    function: 'PRO_RETURNPOLICY_VIEW',
    component: ReturnPolicyAddPage,
  },
];

export default returnPolicyRoute;
